import Rest from '@/services/Rest';

/**
 * @typedef {GatewayService}
 */
export default class GatewayService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/gateway'
}
